import { render, staticRenderFns } from "./ReopenAssignment.vue?vue&type=template&id=4e0e0226"
import script from "./ReopenAssignment.vue?vue&type=script&lang=js"
export * from "./ReopenAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports